export default __webpack_public_path__ + "c24362b60888049fd2f10aea038d4f84.jpeg";